module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "vux-table",
    class: {
      'vux-table-bordered': _vm.fullBordered, 'vux-table-no-cell-bordered': !_vm.cellBordered, 'vux-table-no-content-bordered': !_vm.contentBordered
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e169e96e"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/x-table/index.vue
// module id = 555
// module chunks = 4